import { REQUEST_EDITOR_TOUR, UPDATE_PATH_PARAMS } from '../actions/ActionTypes';
import PortalIdParser from 'PortalIdParser';
import { hasReadOnlyUrl } from '../utils/urls';
const getInitialPathParams = () => {
  const paths = window.location.pathname.split('/');
  return paths.slice(paths.indexOf(`${PortalIdParser.get()}`) + 1).filter(val => !!val);
};
const INITIAL_STATE = {
  pathParams: getInitialPathParams(),
  readOnlyTestFlag: hasReadOnlyUrl(),
  requestedEditorTour: false
};
const pageState = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_PATH_PARAMS:
      return Object.assign({}, state, {
        pathParams: action.pathParams
      });
    case REQUEST_EDITOR_TOUR:
      return Object.assign({}, state, {
        requestedEditorTour: true
      });
    default:
      return state;
  }
};
export default pageState;